<div class="auth-container reset-password-container">
  <div>
    <h1 class="primary-font-semibold heading">
      {{ 'authentication.create_password' | translate }}
    </h1>
    <p class="primary-font-medium form-description">
      {{ 'authentication.create_password_details' | translate }}
    </p>
  </div>

  @if (resetPasswordForm.hasError('serverValidation')) {
    <div class="error-message-container">
      <p class="error-message primary-font-medium form-description">
        {{ serverValidationError() }}
      </p>
    </div>
  }

  <form
    [formGroup]="resetPasswordForm"
    class="form-container"
    (ngSubmit)="handleResetPasswordSubmission().subscribe()"
    [appMarkFormTouched]="resetPasswordForm"
  >
    <div class="form-group">
      <label class="primary-font-medium form-label" for="newPassword">{{
        'authentication.create_new_password' | translate
      }}</label>
      <div class="password-input-container">
        <app-password-input>
          <input
            id="newPassword"
            formControlName="newPassword"
            class="form-input primary-font-medium"
            appErrorStateHighlight
            [errorStateControl]="resetPasswordForm.controls.newPassword"
            placeholder="************"
          />
        </app-password-input>
      </div>

      <!-- Error message -->
      @if (
        resetPasswordForm.get('newPassword')?.hasError('required') &&
        (resetPasswordForm.get('newPassword')?.dirty ||
          resetPasswordForm.get('newPassword')?.touched)
      ) {
        <div class="error-message-container">
          <span class="error-message primary-font-regular invalid-password">
            {{ getFieldErrorMessage('newPassword') | translate }}
          </span>
        </div>
      } @else if (
        resetPasswordForm.get('newPassword')?.hasError('pattern') &&
        (!getPasswordValidationStatus().minLength ||
          !getPasswordValidationStatus().hasSpecial ||
          !getPasswordValidationStatus().hasNumber) &&
        (resetPasswordForm.get('newPassword')?.dirty ||
          resetPasswordForm.get('newPassword')?.touched)
      ) {
        <div class="error-message-container">
          <span class="error-message primary-font-regular invalid-password">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
            >
              <g clip-path="url(#clip0_4_11951)">
                <path
                  d="M9 16.4326C12.7279 16.4326 15.75 13.4105 15.75 9.68262C15.75 5.95469 12.7279 2.93262 9 2.93262C5.27208 2.93262 2.25 5.95469 2.25 9.68262C2.25 13.4105 5.27208 16.4326 9 16.4326Z"
                  stroke="#DA2F2F"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 6.68262V9.68262"
                  stroke="#DA2F2F"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 12.6826H9.0075"
                  stroke="#DA2F2F"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_4_11951">
                  <rect width="18" height="18" fill="white" transform="translate(0 0.682617)" />
                </clipPath>
              </defs>
            </svg>
            {{ 'authentication.invalid_password_error' | translate }}
          </span>

          <div class="password-requirements-container">
            <ul class="password-requirements">
              @if (!getPasswordValidationStatus().minLength) {
                <li>
                  <span class="error-message primary-font-regular">{{
                    'authentication.minimum_character_error' | translate
                  }}</span>
                </li>
              }
              @if (!getPasswordValidationStatus().hasSpecial) {
                <li>
                  <span class="error-message primary-font-regular">{{
                    'authentication.one_special_character_error' | translate
                  }}</span>
                </li>
              }
            </ul>
            @if (!getPasswordValidationStatus().hasNumber) {
              <ul class="password-requirements">
                <li>
                  <span class="error-message primary-font-regular">{{
                    'authentication.one_number_error' | translate
                  }}</span>
                </li>
              </ul>
            }
          </div>
        </div>
      } @else if (
        resetPasswordForm.get('newPassword')?.hasError('minlength') &&
        (resetPasswordForm.get('newPassword')?.dirty ||
          resetPasswordForm.get('newPassword')?.touched)
      ) {
        <div class="error-message-container">
          <span class="error-message primary-font-regular invalid-password">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
            >
              <g clip-path="url(#clip0_4_11950)">
                <path
                  d="M9 16.4326C12.7279 16.4326 15.75 13.4105 15.75 9.68262C15.75 5.95469 12.7279 2.93262 9 2.93262C5.27208 2.93262 2.25 5.95469 2.25 9.68262C2.25 13.4105 5.27208 16.4326 9 16.4326Z"
                  stroke="#DA2F2F"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 6.68262V9.68262"
                  stroke="#DA2F2F"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 12.6826H9.0075"
                  stroke="#DA2F2F"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_4_11950">
                  <rect width="18" height="18" fill="white" transform="translate(0 0.682617)" />
                </clipPath>
              </defs>
            </svg>
            {{ getFieldErrorMessage('newPassword') }}
          </span>
        </div>
      }
    </div>

    <app-error-messages
      [control]="resetPasswordForm.controls.confirmPassword"
      [errorKeyMapping]="errorMappings.confirmPassword"
    >
      <div class="form-group">
        <label class="primary-font-medium form-label" for="confirmPassword">{{
          'authentication.re_enter_new_password' | translate
        }}</label>
        <div class="password-input-container">
          <app-password-input>
            <input
              id="confirmPassword"
              formControlName="confirmPassword"
              class="form-input primary-font-medium"
              appErrorStateHighlight
              [errorStateControl]="resetPasswordForm.controls.confirmPassword"
              placeholder="************"
            />
          </app-password-input>
        </div>
      </div>
    </app-error-messages>

    <button
      type="submit"
      class="auth-button primary-button custom-button rounded-pill primary-font-medium"
      [disabled]="resetPasswordForm.invalid"
    >
      @if (isSubmitting()) {
        <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
      } @else {
        {{ 'authentication.continue_button' | translate }}
      }
    </button>
  </form>
</div>
